module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-wildcard-recipient"
  }, [_c('h2', [_vm._v("Personalise")]), _vm._v(" "), _c('div', {
    staticClass: "wildcard"
  }, [_c('div', {
    staticClass: "card",
    style: ('background-image: url(' + _vm.donation.wildcard.img + ')')
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.dear),
      expression: "donation.wildcard.dear"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('dear'), empty: !_vm.donation.wildcard.dear
    },
    attrs: {
      "name": "dear",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.wildcard.dear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "dear", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dear"
    }
  }, [_vm._v("Dear")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.message),
      expression: "donation.wildcard.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('message'),
        empty: !_vm.donation.wildcard.message,
    },
    attrs: {
      "name": "message",
      "type": "text"
    },
    domProps: {
      "value": (_vm.donation.wildcard.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Your personal message")])]), _vm._v(" "), _c('h2', [_vm._v("Recipient details")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.wildcard.email),
      expression: "donation.wildcard.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      error: _vm.errors.has('recepientsemail'),
        empty: !_vm.donation.wildcard.email,
    },
    attrs: {
      "id": "recepientsemail",
      "name": "recepientsemail",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.wildcard.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.wildcard, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "recepientsemail"
    }
  }, [_vm._v("Recipients email")])]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "disabledDates": _vm.disabledFn,
      "name": "scheduledate",
      "minimumView": 'day',
      "format": 'dd/MM/yyyy',
      "input-class": {
        'border-red': _vm.errors.has('scheduledate')
      },
      "maximumView": 'month',
      "initialView": 'day',
      "placeholder": "Date to send"
    },
    model: {
      value: (_vm.donation.wildcard.scheduledate),
      callback: function($$v) {
        _vm.$set(_vm.donation.wildcard, "scheduledate", $$v)
      },
      expression: "donation.wildcard.scheduledate"
    }
  }), _vm._v(" "), _vm._m(0, false, false)], 1), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _vm._m(1, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "scheduledate"
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d40f66d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/donation/WildcardRecipient.vue
// module id = 690
// module chunks = 0